import GroupsIcon from '@mui/icons-material/Groups';
import LogoutIcon from '@mui/icons-material/Logout';
import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';
import QuizIcon from '@mui/icons-material/Quiz';
import { Box, Divider, Drawer, List, ListItemButton, ListItemIcon, ListItemText, Toolbar, Typography } from '@mui/material';
import React from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../Context/AdminAuthContext';

const DRAWER_WIDTH = 220;

const navItems = [
    { label: 'Brokers',      icon: <PeopleIcon />, path: '/admin/brokers' },
    { label: 'Customers',    icon: <PersonIcon />, path: '/admin/customers' },
    { label: 'Quiz Results', icon: <QuizIcon />,   path: '/admin/quiz-results' },
    { label: 'Groups',       icon: <GroupsIcon />, path: '/admin/groups' },
];

export default function AdminLayout() {
    const { isLoggedIn, logoutAdmin } = useAdminAuth();
    const navigate = useNavigate();
    const location = useLocation();

    if (!isLoggedIn) return <Navigate to="/admin/login" replace />;

    return (
        <Box sx={{ display: 'flex' }}>
            <Drawer variant="permanent" sx={{ width: DRAWER_WIDTH, '& .MuiDrawer-paper': { width: DRAWER_WIDTH, boxSizing: 'border-box' } }}>
                <Toolbar>
                    <Typography variant="h6" fontWeight={700} noWrap>Admin</Typography>
                </Toolbar>
                <Divider />
                <List dense>
                    {navItems.map(item => (
                        <ListItemButton
                            key={item.path}
                            selected={location.pathname.startsWith(item.path)}
                            onClick={() => navigate(item.path)}
                        >
                            <ListItemIcon sx={{ minWidth: 36 }}>{item.icon}</ListItemIcon>
                            <ListItemText primary={item.label} />
                        </ListItemButton>
                    ))}
                </List>
                <Divider />
                <List dense>
                    <ListItemButton onClick={() => { logoutAdmin(); navigate('/admin/login'); }}>
                        <ListItemIcon sx={{ minWidth: 36 }}><LogoutIcon /></ListItemIcon>
                        <ListItemText primary="Logout" />
                    </ListItemButton>
                </List>
            </Drawer>

            <Box component="main" sx={{ flexGrow: 1, p: 3, minHeight: '100vh', bgcolor: '#f5f5f5' }}>
                <Outlet />
            </Box>
        </Box>
    );
}
